<!--
* @description 头部导航栏
* @fileName HeaderBar.vue
-->
<template>
  <div class="header_contaienr flex-row">
    <header class="header_left flex-row align-center">
      <img class="header_logo" src="@/assets/images/dnn_logo.png" alt="logo" />
    </header>
    <!-- 导航区域 -->
    <article class="header_center" ref="headerCenter">
      <!-- 菜单区域 -->
      <div class="navs flex-row align-center">
        <div
          class="nav_item flex-row-center align-center"
          :class="
            (item.path === $route.path && hoverIndex === item.path) ||
            item.active ||
            isHome === item.path ||
            hoverIndex === item.path
              ? 'nav_active'
              : ''
          "
          v-for="(item, index) in navList"
          :key="index"
        >
          <div
            class="con cursor-pointer flex-row-center align-center"
            @click="clickNav(item)"
          >
            <span
              class="nav_name font-size-16"
              :class="
                item.active || isHome === item.path || hoverIndex === item.path
                  ? 'nav_hover'
                  : 'font-weight-400'
              "
              >{{ item.name }}</span
            >
          </div>
        </div>
      </div>
    </article>

    <footer class="header_right flex-row-center">
      <div
        class="right-item"
        @click="jumpUrl(`https://www.delauney.ltd/pc_index`)"
      >
        <img src="@/assets/images/guoqi_en.png" alt="" />
        <span>English</span>
      </div>
      <div
        class="right-item"
        @click="jumpUrl(`https://www.dnnbim.com/`)"
      >
        <img src="@/assets/images/icon_sass.svg" alt="" />
        <span>SaaS云</span>
      </div>
    </footer>
  </div>
</template>

<script>
import { getSoftwareList } from "@/api/api.js";
import TitleCategory from "@/components/TitleCategory.vue";
export default {
  name: "HeaderBar",
  components: {
    TitleCategory,
  },
  data() {
    return {
      navList: [],
      activeIndex: "/pc_index", // 当前激活的面板
      hoverIndex: "/pc_index", // 当前激活的面板
      isHome: false,
    };
  },
  computed: {},
  watch: {
    $route: {
      handler(to, form) {
        this.isHome = to.fullPath === "/pc_index" ? "home" : "";
        let paths = to.path.split("/") || ["pc_index"];
        paths = paths.filter((item) => item);
        this.hoverIndex = "/" + paths[0];
      },
      immediate: true,
    },
    "$i18n.locale": function () {
      this.getInIt();
      // this.checkSoftwareList();
    },
  },
  created() {
    this.getInIt();
    // this.checkSoftwareList();
  },
  mounted() {},
  methods: {
    /*
     * @Description: 点击导航
     * @MethodAuthor:  liulian
     * @Date: 2023-06-28 17:18:32
     * @param: ''
     */
    clickNav(item) {
      this.activeIndex = item.path;
      this.hoverIndex = item.path;

      if (item.path && item.key !== "SaaS") {
        if (this.$route.path !== item.path) {
          this.$uniFun.openInCurrentTab(`${item.path}`);
        }
      }
    },

    jumpUrl(url) {
      window.open(url);
    },
    getInIt() {
      this.navList = [
        {
          name: "首页",
          key: "home",
          path: "/pc_index",
          id: "1",
        },

        {
          name: "设计软件产品",
          key: "digital",
          path: "/digital",
          id: "2",
        },
        {
          name: "智能建造产品",
          key: "intelligent",
          path: "/intelligent",
          id: "3",
        },
        {
          name: "数字运维产品",
          key: "D-Twin",
          path: "/dtwin",
          id: "4",
        },
        {
          name: "狄诺尼学院",
          key: "academy",
          path: "/academy",
          id: "5",
        },
        {
          name: "下载中心",
          key: "download",
          path: "/download",
          id: "6",
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.header_contaienr {
  width: 100%;
  height: 80px;
  padding: 0 64px;
  line-height: 80px;
  background: #232323;
  z-index: 9999;
  .header_left {
    height: 100%;
    width: 234px;
    .header_logo {
      width: 234px;
      height: auto;
    }
  }

  .header_center {
    position: relative;
    // padding: 0 3.12%;
    padding: 0 64px;
    flex: 1;
    min-width: 900px;

    .navs {
      height: 100%;
      justify-content: center;
      .nav_item {
        position: relative;
        padding-left: 1%;
        padding-right: 1%;
        margin-right: 4%;
        &:last-child {
          margin-right: 0;
        }
        .nav_name {
          white-space: nowrap;
          color: #fff;
          font-weight: 400;
          &.nav_hover {
            // opacity: 0.8;
            font-weight: 600;
          }
        }
      }
      .nav_item:hover::after,
      .nav_active::after {
        content: "";
        width: 100%;
        height: 4px;
        background-color: #0035fb;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
  }

  .header_right {
    height: 100%;
    width: 168px;
    justify-content: flex-end;
    white-space: nowrap;
    color: #fff;
    .right-item {
      display: flex;
      align-items: center;
      margin-left: 24px;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      img {
        margin-right: 8px;
      }
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        color: #0035fb;
      }
    }
  }
}
</style>
